module.exports = __webpack_public_path__ + "static/img/1_5_1.f8cd576f.jpg";